import type { PrimitiveColor } from '..';

export const systemColorToken: PrimitiveColor['system'] = {
  black: '#000000',
  white: '#FFFFFF',
};

export const grayColorToken: PrimitiveColor['gray'] = {
  50: '#F9F9F9',
  100: '#F3F3F3',
  150: '#EBEBEB',
  200: '#DBDBDB',
  300: '#BDBDBD',
  400: '#999999',
  500: '#767676',
  600: '#505050',
  700: '#404040',
  800: '#242424',
  900: '#111111',
} as const;

export const greenColorToken: PrimitiveColor['green'] = {
  50: '#EBFBF3',
  100: '#C0F2D9',
  200: '#A1EBC7',
  300: '#76E2AE',
  400: '#5CDD9E',
  500: '#33D486',
  600: '#2EC17A',
  700: '#24975F',
  800: '#1C754A',
  900: '#155938',
} as const;

export const blueColorToken: PrimitiveColor['blue'] = {
  50: '#EBF3FF',
  100: '#C1DAFF',
  200: '#A3C9FF',
  300: '#7AB0FF',
  400: '#60A1FF',
  500: '#3889FF',
  600: '#337DE8',
  700: '#2861B5',
  800: '#1F4B8C',
  900: '#183A6B',
} as const;

export const redColorToken: PrimitiveColor['red'] = {
  100: '#FABDBD',
  200: '#F89D9D',
  300: '#F47170',
  400: '#F25555',
  50: '#FDEAEA',
  500: '#EF2B2A',
  600: '#D92726',
  700: '#AA1F1E',
  800: '#831817',
  900: '#641212',
} as const;

export const OrangeColorToken: PrimitiveColor['orange'] = {
  50: '#FEEEE7',
  100: '#FDCBB4',
  200: '#FCB190',
  300: '#FB8E5E',
  400: '#FA783E',
  500: '#F9560E',
  600: '#E34E0D',
  700: '#B13D0A',
  800: '#892F08',
  900: '#692406',
} as const;

export const YellowColorToken: PrimitiveColor['yellow'] = {
  point: '#FFC800',
} as const;
